import * as React from 'react';
import { IconProps } from '.';

export const CarIllustration = (props: IconProps) => (
  <svg width="63" height="41" viewBox="0 0 63 41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_5237_5024)">
      <path
        d="M6.77086 33.6773C6.67374 33.7108 4.77555 33.3646 3.47672 32.098C2.14973 30.8032 1.52886 28.5134 1.52886 28.5134C1.20481 27.212 1.0917 25.8662 1.1939 24.5284C1.22759 24.0964 1.28539 23.6667 1.36701 23.2413C1.41607 22.9859 0.830991 24.7006 0.804049 23.9456C0.788367 23.5054 1.32298 20.5597 1.36701 20.3734C1.84312 18.3362 2.63227 18.6976 2.63227 18.6976C2.63227 18.6976 2.66746 18.6115 2.77543 18.4041C3.0368 17.8998 3.92548 16.4457 5.8299 15.2051C7.86059 13.8799 12.5167 12.4749 13.5891 11.7873C14.3009 11.3339 15.5018 10.5169 17.3254 8.49406C19.149 6.47123 20.592 4.35374 23.8144 2.84918C27.0367 1.34463 28.717 1.57873 32.216 1.34463C35.715 1.11052 39.4957 1.20518 42.3473 1.34463C45.1989 1.48408 47.4327 2.80398 48.184 3.2728C48.9304 3.74122 50.7978 5.3455 51.7769 6.37678C52.7555 7.41313 53.9218 8.96248 54.8113 9.71992C55.696 10.4723 57.0996 11.369 58.3097 12.0711C59.5255 12.7785 61.29 14.2445 61.6423 16.1002C61.9945 17.9558 61.9131 21.422 61.9131 21.422C61.9131 21.422 62.4819 29.5188 61.9131 32.0978C61.3443 34.6768 57.6205 33.6771 57.6205 33.6771L6.77086 33.6773Z"
        className="fill-primary"
        stroke="#191919"
        strokeWidth="2"
      />
      <path
        d="M2.97666 18.6877C2.97666 18.6877 6.92544 18.1895 7.20712 18.3887C7.55797 18.6378 6.0062 21.3332 5.59604 21.8762C5.39338 22.1451 1.91406 23.8392 1.91406 23.8392L1.92391 21.4029L2.97666 18.6869V18.6877Z"
        fill="#FFFEFF"
      />
      <path
        d="M1.14844 24.4371L2.56188 23.7004C2.56188 23.7004 2.95233 22.0904 3.12042 21.3581C3.36403 20.4123 3.6779 19.4863 4.05936 18.588L2.56188 18.7274C2.56188 18.7274 2.0727 19.5694 1.62294 21.4576C1.14361 23.4952 1.14844 24.4371 1.14844 24.4371Z"
        fill="#E6E6E6"
      />
      <path
        d="M15.5762 15.7331C15.685 16.8092 16.8662 16.7844 20.2407 16.7844C22.9349 16.7844 50.0913 17.0386 50.7387 16.7496C51.0549 16.6101 51.4898 16.0173 52.0287 15.2294C52.8391 14.0538 53.2149 13.4956 53.1407 13.0572C52.9974 12.2002 48.5841 6.58534 45.8222 4.92126C43.9095 3.7704 39.7929 3.76594 36.3877 3.7254C33.3039 3.69054 27.4523 3.61575 24.6552 5.42434C20.4886 8.1203 15.4336 14.3232 15.5762 15.7331Z"
        fill="#191919"
      />
      <path
        d="M19.2374 14.6519C19.455 14.926 23.7496 14.8463 27.7422 14.8313C31.8293 14.8163 35.6743 15.0156 35.8028 14.8313C35.8621 14.7466 36.0642 6.01781 35.8967 5.86336C35.7731 5.74885 34.7155 5.8285 33.3712 5.8431C31.1274 5.86803 27.8608 6.22172 25.8048 7.38353C22.2718 9.37089 18.8076 14.1089 19.2374 14.6519Z"
        fill="white"
      />
      <path
        d="M38.3585 6.02289C38.3239 6.08775 38.2596 14.9007 38.3141 14.9361C38.6008 15.1155 49.5476 14.9767 49.6562 14.8315C49.7647 14.6864 50.9461 13.5311 50.9114 13.2423C50.8766 12.9534 47.1849 8.35462 44.6496 6.79533C43.5375 6.10275 38.4168 5.92377 38.3583 6.02309L38.3585 6.02289Z"
        fill="white"
      />
      <path
        d="M18.1709 17.9353C18.4926 18.7923 20.1972 19.1658 21.2943 19.0663C22.9153 18.9169 23.888 17.9653 24.0619 16.0073C24.2646 13.7603 23.2464 12.729 22.5397 12.5945C21.7885 12.4499 18.1411 16.361 18.1411 16.361C18.1411 16.361 17.9041 17.2228 18.1709 17.9353Z"
        fill="#E73C00"
      />
      <path
        d="M20.4976 17.4569C21.6985 17.3274 22.5585 16.2114 22.9737 15.3196C23.3838 14.4278 23.6902 13.0825 22.7662 12.6741C21.6201 12.1708 20.5867 12.7637 19.88 13.5659C19.2567 14.2733 18.0513 15.8827 18.1404 16.3559C18.2293 16.8343 18.8469 17.6363 20.4976 17.4569Z"
        className="fill-primary"
      />
      <path
        d="M8.56303 32.5631C8.60746 35.3132 10.7819 39.2699 15.517 39.2991C20.2522 39.3283 22.7079 35.672 22.5595 31.9255C22.4063 28.119 19.4706 25.4287 15.2452 25.5483C11.2916 25.6679 8.50412 28.7569 8.56343 32.5631H8.56303Z"
        fill="#FFFEFF"
        stroke="#191919"
        strokeWidth="2"
      />
      <path
        d="M11.8591 32.3339C11.8953 33.3017 12.3073 34.2164 13.0061 34.8808C13.705 35.5453 14.6349 35.9064 15.5953 35.8862C18.1405 35.9012 19.3712 34.0823 19.292 32.1097C19.208 30.1019 17.583 28.6073 15.447 28.6371C14.9679 28.6329 14.493 28.7263 14.0506 28.9116C13.6082 29.0969 13.2075 29.3704 12.8724 29.7156C12.5374 30.0608 12.2749 30.4706 12.1008 30.9205C11.9267 31.3704 11.8445 31.8512 11.8591 32.3339Z"
        fill="#DBDBDB"
      />
      <path
        d="M43.5138 32.793C43.5583 35.5232 45.6835 39.4493 50.3191 39.4791C54.9547 39.5089 57.3561 35.882 57.2133 32.1653C57.0652 28.3837 54.1937 25.7184 50.0571 25.8379C46.1873 25.9525 43.4545 29.0165 43.5138 32.793Z"
        fill="#FFFEFF"
        stroke="#191919"
        strokeWidth="2"
      />
      <path
        d="M46.6079 32.578C46.6442 33.5457 47.0561 34.4604 47.755 35.1249C48.4539 35.7894 49.3837 36.1504 50.3442 36.1303C52.8894 36.1453 54.1201 34.3263 54.0409 32.3538C53.9568 30.3459 52.3319 28.8513 50.1958 28.8811C49.717 28.8777 49.2424 28.9716 48.8003 29.1572C48.3583 29.3428 47.9579 29.6163 47.623 29.9613C47.2881 30.3063 47.0256 30.7159 46.8512 31.1655C46.6768 31.615 46.5941 32.0954 46.6079 32.578Z"
        fill="#DBDBDB"
      />
      <path
        d="M60.2924 15.1226C60.1491 15.3269 57.0654 17.7908 57.0654 18.1096C57.0654 18.4284 59.8923 22.5485 59.8923 22.5485L61.0872 23.0295C61.0872 23.0295 61.0966 19.4429 60.9215 17.4484C60.7464 15.454 60.2924 15.1226 60.2924 15.1226Z"
        fill="#FFFEFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_5237_5024">
        <rect width="63" height="40" fill="white" transform="translate(0 0.390564)" />
      </clipPath>
    </defs>
  </svg>
);
